import { Component } from '@theme/component';

if (!customElements.get('mw-contact-prefill')) {
  class MwContactPrefill extends Component {
    #abort;
    #handled = new WeakSet();

    connectedCallback() {
      super.connectedCallback();
      this.#abort?.abort();
      this.#abort = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.#prefill(), {
          once: true,
          signal: this.#abort.signal,
        });
      } else {
        this.#prefill();
      }
    }

    updatedCallback() {
      super.updatedCallback();
      this.#prefill();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.#abort?.abort();
    }

    #prefill() {
      const message = this.querySelector('textarea[name="contact[body]"]');
      if (!(message instanceof HTMLTextAreaElement) || this.#handled.has(message)) return;
      this.#handled.add(message);
      if (message.value.trim() || message.dataset.advicePreserve === 'true') return;

      const params = new URLSearchParams(window.location.search);
      const handle = params.get('product') || '';
      let products;
      try {
        products = JSON.parse(this.dataset.adviceProducts || '{}');
      } catch {
        return;
      }
      if (!products || !Object.prototype.hasOwnProperty.call(products, handle)) return;
      const title = products[handle];
      if (typeof title !== 'string' || !title.trim()) return;

      const lines = [(this.dataset.productLine || '').replace('[product]', title)];
      const volume = params.get('volume');
      if (['2.5', '5', '10'].includes(volume)) {
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'nl').format(Number(volume));
        lines.push((this.dataset.volumeLine || '').replace('[volume]', formatted));
      }

      let colour = '';
      if (handle === 'dekkende-voorstrijk-wit') {
        colour = this.dataset.whiteLabel || '';
      } else if (params.get('mode') === 'ral') {
        const ral = params.get('ral') || '';
        if (/^\d{4}$/.test(ral)) colour = `RAL ${ral}`;
      } else if (params.get('mode') === 'other') {
        const clean = (value, limit) => (value || '').replace(/[\u0000-\u001f\u007f-\u009f\u2028\u2029]/g, '').trim().slice(0, limit);
        colour = [clean(params.get('brand'), 80), clean(params.get('colour'), 120)].filter(Boolean).join(' · ');
      }
      if (colour) lines.push((this.dataset.colourLine || '').replace('[colour]', colour));
      message.value = `${lines.join('\n')}\n\n${this.dataset.questionLabel || ''}\n`;
    }
  }

  customElements.define('mw-contact-prefill', MwContactPrefill);
}
